module.exports = __webpack_public_path__ + "img/covid-pills.1aa40f09.png";